import { render } from "./password-msg-box.vue?vue&type=template&id=6267b271&scoped=true&ts=true"
import script from "./password-msg-box.vue?vue&type=script&lang=ts"
export * from "./password-msg-box.vue?vue&type=script&lang=ts"

import "./password-msg-box.vue?vue&type=style&index=0&id=6267b271&lang=scss&scoped=true"

import exportComponent from "D:\\project\\fantan\\h5\\fantan\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6267b271"]])

export default __exports__